/**
 * Creates a record object keyed with `by` objects' property
 */
export const recordBy = <T, K extends keyof T>(list: T[], by: K) => {
  const result = {} as Record<string, T>;
  if (list == null || !list.length || by == null) {
    // null safe
    return result;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const item of list) {
    result[String(item[by])] = item;
  }

  return result;
};
